export const TestHooks = {
	AddButton: 'add-button',
	Button: 'button',
} as const;
